module.exports = __webpack_public_path__ + "img/orbit-2.aa017093.svg";